import React from "react";

const Bar = ({ w, h = 3, color = "#cbd5e1" }) => (
  <div className="rounded-[1px]" style={{ width: w, height: h, background: color }} />
);

const BulletLine = ({ w, accent, scale }) => (
  <div className="flex items-start" style={{ gap: 3 * scale }}>
    <div className="shrink-0 rounded-full" style={{ width: 2 * scale, height: 2 * scale, marginTop: 2 * scale, background: accent }} />
    <Bar w={w} h={2.2 * scale} />
  </div>
);

const Block = ({ accent, bullets = 2, scale, width = "58%" }) => (
  <div style={{ display: "grid", gap: 2.5 * scale }}>
    <Bar w={width} h={3 * scale} color={accent} />
    {Array.from({ length: bullets }).map((_, i) => <BulletLine key={i} w={i === bullets - 1 ? "78%" : "100%"} accent={accent} scale={scale} />)}
  </div>
);

/** A readable miniature of the real layout: header, rule, section headings and bulleted lines. */
const TemplateThumbnail = ({ tpl, size = "sm" }) => {
  const scale = size === "lg" ? 1.9 : size === "md" ? 1.35 : 1;
  const align = tpl.nameAlign === "center" ? "items-center" : "items-start";
  return (
    <div
      className={`bg-white overflow-hidden flex flex-col ${align}`}
      style={{
        width: 80 * scale, height: 112 * scale, padding: 7 * scale, gap: 5 * scale,
        fontFamily: tpl.serif ? "Georgia, serif" : "Inter, sans-serif",
        borderTop: tpl.heading === "bar" ? `${3 * scale}px solid ${tpl.accent}` : "none",
      }}
    >
      <div className={`flex flex-col w-full ${align}`} style={{ gap: 2.5 * scale }}>
        <Bar w="62%" h={5.5 * scale} color="#334155" />
        <Bar w="40%" h={3 * scale} color={tpl.accent} />
        <Bar w="52%" h={2 * scale} color="#cbd5e1" />
      </div>
      <div style={{ height: 1, width: "100%", background: "#e2e8f0" }} />
      {tpl.layout === "two" ? (
        <div className="flex w-full flex-1" style={{ gap: 5 * scale }}>
          <div style={{ width: "34%", display: "grid", gap: 4 * scale, borderRight: "1px solid #e2e8f0", paddingRight: 4 * scale }}>
            <Block accent={tpl.accent} bullets={3} scale={scale} width="80%" />
            <Block accent={tpl.accent} bullets={2} scale={scale} width="70%" />
          </div>
          <div className="flex-1" style={{ display: "grid", gap: 4 * scale, alignContent: "start" }}>
            <Block accent={tpl.accent} bullets={2} scale={scale} />
            <Block accent={tpl.accent} bullets={3} scale={scale} />
          </div>
        </div>
      ) : (
        <div className="w-full flex-1" style={{ display: "grid", gap: 4 * scale, alignContent: "start" }}>
          <Block accent={tpl.accent} bullets={2} scale={scale} />
          <Block accent={tpl.accent} bullets={3} scale={scale} />
          <Block accent={tpl.accent} bullets={2} scale={scale} width="48%" />
        </div>
      )}
    </div>
  );
};

export default TemplateThumbnail;
